import { api } from "..";

const endpoint = "/api/payment-conditions";

export const getPaymentConditionList = () => {
  return api.get(endpoint);
};
